<template>
  <a :href="article.sourceUrl" class="article-a" target="_blank">
    <div class="dynamic-article">
      <div class="article-about">
        <div class="article-text">
          <h3 class="article-title">{{ article.title }}</h3>
          <div class="article-digest">{{ article.digest }}</div>
        </div>
        <div class="article-time">{{ article.publishTime }}</div>
      </div>
      <div class="aticle-image">
        <el-image :src="article.thumbUrl" fit="cover"></el-image>
      </div>
      <div class="clear"></div>
    </div>
  </a>
</template>

<script>
  export default{
    name: "Article",
    props: [
      "article"
    ]
  }
</script>

<style>
  .dynamic-article{
    margin: 10px 0;
    border: 1px solid #efefef;
    padding: 10px;
  }
  .article-about{
    width: 65%;
    float: left;
  }
  .aticle-image{
    float: right;
    padding: 2px;
    border: 1px solid #efefef;
  }
  .el-image{
    display: block;
    width: 200px;
    height: 200px;
  }
  .el-image img{
    transition: all 0.3s linear;
  }
  .article-a:hover img{
    transform: scale(1.1,1.1);
  }
  .article-a:hover .article-title{
    color: #000;
    transition: all 1s linear;
  }
  .article-title{
    font-size: 24px;
    color: #000;
    text-align: left;
    font-weight: normal;
    display: -webkit-box;
    display: -moz-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2;
  }
  .article-digest{
    margin-top: 10px;
    text-indent: 2em;
    text-align: left;
    color: #666;
    display: -webkit-box;
    display: -moz-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:4;
  }
  .article-text{
    height: 185px;
    overflow: hidden;
  }
  .article-time{
    color: #666;
    text-align: left;
  }
  @media screen and (max-width: 1200px) {
    .article-about{
      width: 60%;
    }
    .article-title{
      font-size: 20px;
    }
    .article-digest{
      font-size: 15px;
      -webkit-line-clamp:3;
    }
    .article-time{
      font-size: 15px;
    }
  }
  @media screen and (max-width: 768px) {
    .dynamic-article{
      padding: 5px;
    }
    .article-title{
      font-size: 14px;
      line-height: 16px;
    }
    .el-image{
      width: 100px;
      height: 100px;
    }
    .article-digest{
      margin-top: 3px;
      font-size: 12px;
    }
    .article-text{
      height: 90px;
    }
    .article-about{
      width: 58%;
    }
    .article-time{
      font-size: 12px;
    }
  }
</style>
